import { FC } from 'react';
// Components
import Analytics from './Analytics';
import { Toolbar } from 'components/Toolbar';
// i18next
import { useTranslation } from 'react-i18next';

const AnalyticsPage:FC = () => {
  const { t } = useTranslation();

  return (
    <div className="container max-w-screen-desktop flex-grow py-4 overflow-y-auto">
      <Toolbar title={t('pages.analytics.title')} />
      <Analytics />
    </div>
  );
}

export default AnalyticsPage;
